export const versionInfo = {
  version: "v0.6.1",
  buildDate: "20.08.2024",
  author: "Dirk & Patrick Lammers"
}
